@if (isMobile()) {
  <boels-vertical-aligner
    class="boels-product-grid__container mobile-view-only"
  >
    <ng-container [ngTemplateOutlet]="boelsProductGrid"></ng-container>
  </boels-vertical-aligner>
} @else {
  <div class="boels-product-grid__container desktop-view-only">
    <ng-container [ngTemplateOutlet]="boelsProductGrid"></ng-container>
  </div>
}

<ng-template #boelsProductGrid>
  @if ($productSearchPage(); as productSearchPage) {
    @if (productSearchPage?.pagination?.totalResults) {
      <div infiniteScroll (scrolled)="onScroll(productSearchPage)">
        @if ($seo(); as seo) {
          <h1>
            {{
              seo.name ?? productSearchPage?.breadcrumbs?.[0]?.facetValueName
            }}
          </h1>
          <boels-total-products
            class="mobile-view-only"
            [productCount]="productSearchPage?.pagination?.totalResults || 0"
          >
          </boels-total-products>
          @if (seo.description) {
            <div
              class="boels-product-grid__seo-description"
              [innerHtml]="seo?.description | prepareHtml"
            ></div>
          }
        }
        <div class="boels-product-grid__options">
          <boels-total-products
            class="desktop-view-only"
            [productCount]="productSearchPage?.pagination?.totalResults || 0"
          >
          </boels-total-products>
          <boels-sorting
            [sortOptions]="productSearchPage?.sorts"
          ></boels-sorting>
        </div>
        @if (componentData.data$ | async; as componentData) {
          <div class="boels-product-grid__products">
            @for (
              product of productSearchPage?.products;
              track product;
              let i = $index
            ) {
              <boels-product-card
                ngSkipHydration
                [$product]="product"
                [product]="product"
                [productIndex]="i"
                [componentName]="componentData.uid || ''"
                boelsDataDm
              ></boels-product-card>
            }
          </div>
        }
      </div>
    }
    @if (showBackToTopButton(productSearchPage)) {
      <boels-back-to-top></boels-back-to-top>
    }
    @if (productSearchPage?.pagination?.totalResults) {
      <hr />
    }
    @if ($seo()?.seoText) {
      <div
        class="boels-product-grid__seo-text"
        [innerHtml]="$seo()?.seoText | prepareHtml"
      ></div>
    }
  } @else if ($productSearchPageLoading()) {
    <div class="boels-product-grid__spinner-container">
      <boels-spinner></boels-spinner>
    </div>
  }
</ng-template>
